export const status = ["Continuous Improvement", "Kaizen", "Observations"];

export const GRID_CONFIG = {

    noDataText: "No Incident",
    showBorders: true,
    rowAlternationEnabled: true,
    allowColumnReordering: true,
    allowColumnResizing: true,
    columnResizingMode: "widget",
    columnAutoWidth: true,
    columnChooser: {
        enabled: true,
        allowSearch: true,
        mode: "select"
    },
    editing: {
        mode: "popup",
        allowUpdating: true,
        allowAdding: true,
        allowDeleting: true,
        useIcons: true,
        popup: {
            title: "Incident",
            showTitle: true,
            position: {
                my: "center",
                at: "center",
                of: window
            }
        },
    },
   
    headerFilter: {
        visible: true
    },
    sorting: {
        mode: "multiple"
    },
    grouping: {
        contextMenuEnabled: true
    },
    searchPanel: {
        visible: true
    },
    filterRow: {
        visible: true,
        applyFilter: "auto"
    },
    
    export: {
        enabled: true,
        fileName: "Incident"
    },
    
    onToolbarPreparing: function (e) {
        var dataGrid = e.component;
        var toolbarItems = e.toolbarOptions.items;
        // Adds a new item
        toolbarItems.unshift(

            {
                location: "after",
                widget: "dxButton",
                options: {
                    icon: "refresh",
                    hint: "Refresh",
                    onClick: function () {
                        dataGrid.refresh();
                    }
                }
            });
    }
}

export const GRID_COL_DEF = [
    {
    dataField: "incidentDate",
    dataType: "date",
    validationRules: [{ type: "required" }]
},{
    dataField: "incidentType",
    caption: "Incident Type",
    validationRules: [{ type: "required" }]
}, {
    dataField: "description",
    caption: "Description",
    cssClass: "WrappedColumn",
    validationRules: [{ type: "required" }]
},  {
    dataField: "submitter",
    caption: "Submitter",
    validationRules: [{ type: "required" }]
}];

